/**
 * Why these live here rather than being imported from Lightyear's `imageBrowse/helpers/errorStates`:
 * these describe a single image, which is shared-viewer territory, and Lightyear's copy describes an
 * image group. The values are deliberately identical so the two can be compared if they ever meet.
 */
export const imageErrorStates = {
  UNAUTHORIZED: 'UNAUTHORIZED',
  NOT_FOUND: 'NOT_FOUND',
  UNAVAILABLE: 'UNAVAILABLE',
}

/**
 * Maps an HTTP status from an image lookup onto the error state to show the user.
 *
 * @param {number} status - HTTP status code.
 * @returns {string|null} An `imageErrorStates` value, or null when the status isn't an error.
 */
export function getImageErrorState(status) {
  if (!status || status < 300) return null
  if (status === 401 || status === 403) return imageErrorStates.UNAUTHORIZED
  if (status === 404) return imageErrorStates.NOT_FOUND
  return imageErrorStates.UNAVAILABLE
}
